import { createFileRoute } from "@tanstack/react-router";
import AdminSupportPage from "@/admin/pages/support";

export const QUEUE_SORT_KEYS = [
  "created",
  "updated",
  "subject",
  "requester",
  "status",
  "priority",
  "assignee",
  "channel",
  "sla",
] as const;
export type QueueSortKey = (typeof QUEUE_SORT_KEYS)[number];
export type SortDir = "asc" | "desc";

/**
 * Everything the queue needs to rebuild itself lives in the URL: a ticket is a search
 * param (so Back closes it and lands on the same filtered page), and filters, search
 * text, page and sort are shareable.
 */
export type AdminSupportSearch = {
  tab?: "macros";
  ticket?: string;
  status?: string;
  /** Narrow the queue to one member (from their user-detail page). */
  user_id?: string;
  assignee?: string;
  priority?: string;
  channel?: string;
  tag?: string;
  breached?: boolean;
  member_replied?: boolean;
  q?: string;
  page?: number;
  sort?: QueueSortKey;
  dir?: SortDir;
};

const str = (v: unknown): string | undefined => (typeof v === "string" && v ? v : undefined);

export const Route = createFileRoute("/admin/support")({
  component: AdminSupportPage,
  validateSearch: (search: Record<string, unknown>): AdminSupportSearch => ({
    tab: search.tab === "macros" ? "macros" : undefined,
    ticket: str(search.ticket),
    status: str(search.status),
    user_id: str(search.user_id),
    assignee: str(search.assignee),
    priority: str(search.priority),
    channel: str(search.channel),
    tag: str(search.tag),
    breached: search.breached === true || search.breached === "true" ? true : undefined,
    member_replied:
      search.member_replied === true || search.member_replied === "true" ? true : undefined,
    q: str(search.q),
    page:
      typeof search.page === "number" && Number.isInteger(search.page) && search.page > 0
        ? search.page
        : undefined,
    sort: QUEUE_SORT_KEYS.includes(search.sort as QueueSortKey)
      ? (search.sort as QueueSortKey)
      : undefined,
    dir: search.dir === "asc" || search.dir === "desc" ? search.dir : undefined,
  }),
});
